import script from "./TaskAddForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskAddForm.vue?vue&type=script&setup=true&lang=js"

import "./TaskAddForm.vue?vue&type=style&index=0&id=58c6a76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c6a76e"]])

export default __exports__